@for (productTag of productTagList; track productTag) {
  @if (productTag.type == 1 || productTag.type == 4) {
    <img src="assets/images/{{productTag.type}}.png">
  }
}